export default "__VITE_ASSET__ClnPtlRA__"